<template>
  <div class="content-message">
    <div class="top">
      <div class="back" @click="back">
        <img src="@/assets/img/icon_return.png" alt="">
        <div class="back-text">返回</div>
      </div>
      <div class="title">{{ payStatus == 1?'添加':'续费' }}{{ typeStatus == 1 ? '公众号' : '票务号' }}</div>
    </div>
    <div class="center">
      <div class="center-item" v-if="saasMovieScribingPrice!='' && typeStatus == 1">
        <div class="center-title" style="color: red;">现价：</div>
        <div class="center-text" style="color: red;">{{ price.fee }}元/年</div>
        <div class="hint-box" v-if="saasMarketingLanguage !=''"><div class="bor"></div>{{ saasMarketingLanguage }}</div>
      </div>
      <div class="center-item" style="margin-top: 20px" v-if="typeStatus == 1 && saasMovieScribingPrice!=''">
        <div class="center-title" style="text-decoration: line-through">原价：</div>
        <div class="center-text"  style="text-decoration: line-through">{{ saasMovieScribingPrice }}元/年</div>
      </div>
      <div class="center-item" style="margin-top: 20px" v-if="typeStatus == 1 && saasMovieScribingPrice == '' ">
        <div class="center-title">价格：</div>
        <div class="center-text" >{{ price.fee }}元/年</div>
      </div>
      <div class="center-item" style="margin-top: 20px" v-if="typeStatus != 1 ">
        <div class="center-title">价格：</div>
        <div class="center-text" >{{ price.fee }}元/年</div>
      </div>
      <div class="center-item" style="margin-top: 20px">
        <div class="center-title">合计支付：</div>
        <div class="center-number">{{ totalFee }}<span>元</span></div>
      </div>
      <div class="center-item" style="margin-top: 20px" v-if="payStatus == 2">
        <div class="center-title">续费年限：</div>
        <el-input v-model="number" style="width: 160px;" size="small" @blur="getTotal"></el-input>
        <div class="center-text" style="margin-left: 10px">年</div>
      </div>
    </div>
    <div class="pay">
      <div class="pay-text">支付方式：</div>
      <div class="pay-item" v-for="(item,index) in typeList" :key="index" :class="type == index?'pay-item-active':''"
           @click="select(index)">
        <img :src="item.image" alt="">
        <div class="pay-item-text"> {{ item.text }}</div>
      </div>
    </div>
<!--    <div class="pay-qrcode">-->
<!--      <img class="bg" src="@/assets/img/promotion/pay_bg.png" alt="">-->
<!--      <img class="imageQrcode" :src="payQrcode" alt="">-->
<!--    </div>-->
    <div class="pay-qrcode">
      <div class="qrcode-top">
        <img :src="isPayImg" alt="">
        <div class="qrcode-top-text">{{isPayTitle}}</div>
      </div>
      <div class="qrcode-center" :style="'background:' + isPayBgColor">
        <div class="qrcode-center-img">
          <img :src="payQrcode" alt="">
        </div>
        <div class="qrcode-center-text">{{isPayText}}</div>
      </div>
    </div>
<!--    <div class="bottom">-->
<!--      <div class="bottom-button" @click="toPayment">付款完成</div>-->
<!--    </div>-->
  </div>
</template>

<script>
import {saasIndex} from "@/javaApi/saasIndex";
const saasM = new saasIndex
// import {contactSocket,doSend} from '@/utils/websocket'
import {getUserUUID,} from '@/utils/auth'

export default {
  name: "index",
  data() {
    return {
      // 提现类别
      typeList: [
        // {
        //   text: '银行卡',
        //   show: 0,
        //   image: require('@/assets/img/icon_ylzf_3.png')
        // },
        {
          text: '微信',
          show: 0,
          image: 'https://web.taototo.cn/seller/image/withdrawal_btn_wechat.png'
        }, {
          text: '支付宝',
          show: 0,
          image: 'https://web.taototo.cn/seller/image/withdrawal_btn_alipay.png'
        }
      ],
      type: 0,
      number: 1,
      price: '',
      payStatus: '',
      typeStatus: '',
      buyType: '', // 类型
      payQrcode: '', // 支付二维码
      totalFee: '', // 总价格
      paySuccess: false,
      businessId:'',
      saasMovieScribingPrice:'',
      saasMarketingLanguage:'',
      isPayTitle:'微信', //标题
      isPayText:'用微信扫一扫付款', // 提示
      isPayImg:'https://web.taototo.cn/seller/image/withdrawal_btn_wechat.png', // 图片
      isPayBgColor:'', // 背景色
    }
  },
  mounted() {
    this.payStatus = this.$route.query.payStatus
    this.typeStatus = this.$route.query.type
    this.businessId = this.$route.query.id
    if (this.typeStatus == 1) {
      this.getOfficial()
    } else {
      this.getTicket()
    }
    this.paySuccess = localStorage.getItem('paySuccess')
    this.webSocket()
  },
  methods: {
    // 选择提现方式
    select(index) {
      this.type = index
      if(index == 1){
        this.isPayTitle = '支付宝'
        this.isPayText = '打开支付宝[扫一扫]'
        this.isPayImg = 'https://web.taototo.cn/seller/image/withdrawal_btn_alipay.png'
        this.isPayBgColor = '#00AAEE'
      }
      if(index == 0){
        this.isPayTitle = '微信支付'
        this.isPayText = '用微信扫一扫付款'
        this.isPayImg = 'https://web.taototo.cn/seller/image/withdrawal_btn_wechat.png'
        this.isPayBgColor = '#0EC060'
      }
      if(index == 3){
        this.isPayTitle = '银联支付'
        this.isPayText = '请使用云闪付或各大银行app扫码'
        this.isPayImg = 'https://yingpiao.oss-cn-shenzhen.aliyuncs.com/images/tixian_icon_bank%402x.png'
        this.isPayBgColor = '#0067B7'
      }
      this.getPayQrcode()

    },
    // 返回
    back() {
      this.$router.back()
    },
    // 跳转支付完成
    toPayment() {
      this.$router.push('/pc/SaasJoin/pay/paymentStatus')
    },
    // 获取公众号支付价格
    getOfficial() {
      let params;
      if (this.payStatus == 2) {
        params = {
          type: this.payStatus,
          year: this.number,
        }
      } else {
        params = {
          type: this.payStatus,
        }
      }
      saasM.officialPrice(params).then(res => {
        if (res.data.code == 200) {
          console.log(res)
          this.saasMovieScribingPrice = res.data.data.saasMovieScribingPrice
          this.saasMarketingLanguage = res.data.data.saasMarketingLanguage
          this.price = res.data.data
          this.buyType = res.data.data.buyType
          this.totalFee = res.data.data.totalFee
          this.getPayQrcode()
        } else {
          this.$Message.error(res.data.info || res.data.message)
        }
      })
    },
    // 票务号支付价格
    getTicket() {
      let params;
      if (this.payStatus == 2) {
        params = {
          type: this.payStatus,
          year: this.number
        }
      } else {
        params = {
          type: this.payStatus,
        }
      }
      saasM.ticketPrice(params).then(res => {
        if (res.data.code == 200) {
          console.log(res)
          this.price = res.data.data
          this.buyType = res.data.data.buyType
          this.totalFee = res.data.data.totalFee
          this.getPayQrcode()
        } else {
          this.$Message.error(res.data.info || res.data.message)
        }
      })
    },
    // 获取支付二维码
    getPayQrcode() {
      let params = {
        money: this.totalFee,
        paymentMethod: this.type + 1,
        buyType: this.buyType,
        businessId:this.businessId,
        year: this.number
      }
      saasM.peyQrcode(params).then(res => {
        if (res.data.code == 200) {
          console.log(res)
          this.payQrcode = 'data:image/jpeg;base64,' + res.data.data.scanCode
        } else {
          this.$Message.error(res.data.info || res.data.message)
        }
      })
    },
    // 计算年数和价格
    getTotal() {
      this.totalFee = this.price.fee * this.number
      this.getPayQrcode()
    },
    // 用webSocket实时获取订单是否支付支付成功跳转
    webSocket() {
      var that = this
      let webSocket = null;
      let socketOpen = false;
// 发送消息
      let userUUId = localStorage.getItem('userUUID')
// 初始化websocket
      if ("WebSocket" in window) {
        webSocket = new WebSocket(process.env.VUE_APP_SAAS_MOVIE_WEBSOCKET + 'ws/ticket-order/' + userUUId);
        webSocket.onopen = function () {
          console.log(process.env.VUE_APP_SAAS_MOVIE_WEBSOCKET + 'ws/ticket-order/' + userUUId)
          console.log("连接成功！");
          socketOpen = true
        };
        webSocket.onmessage = function (evt) {
          var received_msg = evt.data;
          console.log("接受消息：" + received_msg);
          let message = JSON.parse(received_msg)
          if (message.status == 'success') {
            localStorage.setItem('orderUuid', message.orderUuid)
            localStorage.setItem('paySuccess', true)
            localStorage.setItem('buyType', message.buyType)
            localStorage.setItem('typeStatus', that.typeStatus)
            localStorage.setItem('payStatus', that.payStatus)
            that.toPayment()
          }
        };
        webSocket.onclose = function () {
          console.log("连接关闭！");
        };
        webSocket.onerror = function () {
          console.log("连接异常！");
        };
      }

    }
  }
}
</script>

<style scoped lang="less">
.content-message {
  background: #FFFFFF;
  border-radius: 8px;
  padding: 20px;
  min-height: 92%;
  position: relative;

  .top {
    display: flex;
    align-items: center;

    .back {
      width: 88px;
      height: 32px;
      background: #FFFFFF;
      border-radius: 2px;
      border: 1px solid #EEEEEE;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;

      img {
        width: 24px;
        height: 24px;
      }

      .back-text {
        font-size: 14px;
        font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
        font-weight: normal;
        color: #666666;
        line-height: 20px;
      }
    }

    .title {
      font-size: 18px;
      font-family: Alibaba-PuHuiTi-M, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #222222;
      line-height: 25px;
      margin-left: 20px;
    }
  }

  .center {
    margin-top: 37px;
    padding: 30px;
    border-radius: 4px;
    border: 1px solid #EEEEEE;

    .center-item {
      display: flex;
      align-items: center;

      .center-title {
        font-size: 14px;
        font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
        font-weight: normal;
        color: #666666;
        line-height: 20px;
        width: 70px;
        text-align: right;
      }

      .center-text {
        font-size: 14px;
        font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
        font-weight: normal;
        color: #666666;
        line-height: 20px;
      }

      .center-number {
        font-size: 24px;
        font-family: Alibaba-PuHuiTi-M, Alibaba-PuHuiTi;
        font-weight: normal;
        color: #FF8622;
        line-height: 33px;

        span {
          font-size: 14px;
          font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
          font-weight: normal;
          color: #666666;
          line-height: 20px;
        }
      }
    }
  }
}

.pay {
  display: flex;
  margin-top: 20px;

  .pay-item {
    width: 160px;
    height: 48px;
    background: #FFFFFF;
    border-radius: 2px;
    border: 1px solid #E8E8E8;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 20px;
    cursor: pointer;

    img {
      width: 28px;
      height: 28px;
    }

    .pay-item-text {
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #3F3A39;
      line-height: 25px;
      margin-left: 5px;
    }
  }

  .pay-item-active {
    border-radius: 2px;
    border: 1px solid #FF8622;
  }
}

.pay-qrcode {
  margin-top: 20px;
  margin-left: 64px;
  position: relative;
  width: 240px;

  .bg {
    width: 240px;

  }
}

.bottom {
  height: 60px;
  background: #FFFFFF;
  border-radius: 0px 0px 8px 8px;
  position: absolute;
  bottom: 0;
  width: 96%;
  border-top: 1px solid #e5e5e5;
  display: flex;
  align-items: center;
  justify-content: center;

  .bottom-button {
    width: 136px;
    height: 36px;
    background: #FF8622;
    border-radius: 2px;
    text-align: center;
    font-size: 14px;
    font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
    font-weight: normal;
    color: #FFFFFF;
    line-height: 36px;
  }
}

.imageQrcode {
  position: absolute;
  width: 120px;
  height: 120px;
  right: 60px;
  bottom: 34px;

}
.hint-box{
  padding: 8px 16px;
  background: #FFF5F7;
  border: 1px solid #FFCAD5;
  font-size: 14px;
  font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
  font-weight: normal;
  color: #FF4F76;
  line-height: 20px;
  margin-left: 12px;
  position: relative;
  .bor{
    width: 0;
    height: 0;
    border-right: 8px solid #FFF5F7;
    border-top: 8px solid transparent;
    border-bottom: 6px solid transparent;
    position: absolute;
    left: -8px;
    top: 0;
    bottom: 0;
    margin: auto;
  }
}
.pay-qrcode{
  width: 220px;
  height: 300px;
  background: #FFFFFF;
  box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.06);
  margin-top: 30px;
  .qrcode-top{
    height: 60px;
    background: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    img{
      width: 28px;
      height: 28px;
    }
    .qrcode-top-text{
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #222222;
      line-height: 25px;
      margin-left: 8px;
    }
  }
  .qrcode-center{
    width: 220px;
    height: 240px;
    background: #0EC060;
    padding-top: 40px;
    .qrcode-center-img{
      width: 120px;
      height: 120px;
      background: #FAFAFA;
      margin: auto;
      img{
        width: 100%;
        height: 100%;
      }
    }
    .qrcode-center-text{
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #FFFFFF;
      line-height: 20px;
      margin-top: 20px;
      text-align: center;
    }
  }
}
/deep/ .el-dialog__header {
  border-bottom: 1px solid #e5e5e5;
}

/deep/ .el-input__inner:focus {
  border-color: #FF8622 !important;
}

/deep/ .el-range-editor.is-active, .el-range-editor.is-active:hover {
  border-color: #FF8622 !important;
}

/deep/ .el-date-table td.today {
  background: #FF8622;
}

/deep/ .el-input__inner:hover {
  background: #FCF8F5;
  border-color: #FF8622 !important;
}

/deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
  background: #FF8622 !important;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/SaasJoin/pay/index.vue